import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Permission } from "../../../interfaces/permission";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PermissionService } from "../../../services/permission.service";
import { PlantService } from "../../../services/plant.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Response } from "../../../interfaces/response";
import { IPlant } from 'src/app/interfaces/plant';

@Component({
  selector: 'app-plant-save',
  templateUrl: './plant-save.component.html',
  styleUrls: ['./plant-save.component.css']
})
export class PlantSaveComponent implements OnInit {

  form: FormGroup;
  plant: IPlant;
  //modoEdicion: boolean = false;

  @Input() closeMyModal: (any) => void;
  @Input() id: any;
  @Input() tipo: any;
  @Output() salida: EventEmitter<any> = new EventEmitter();


  constructor(
    private formBuilder: FormBuilder,
    private plantService: PlantService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id_planta: ['', Validators.required],
      nom_planta: ['', Validators.required],
    });

    //this.modoEdicion = true;


    this.plantService.get(this.id)
      .subscribe(
        (res: Response) => {
          this.plant = res.data;
          this.form.patchValue({
            id_planta: this.plant.id_planta,
            nom_planta: this.plant.nom_planta
          });
        },
        err => console.log('HTTP Error', err)
      );
  };






submit() {

  const data = this.form.getRawValue();


  if (this.tipo=="edit") {
    // editar el registro
    this.plantService.update(this.plant.id, data).subscribe(
      (res: Response) => {
        this.salida.emit(res);
        //console.log(res.data);

      },

      //res => {
       // this.salida.emit(res);
       // console.log(res.data);
       // if (res.data==true){

       // }

       // this.router.navigate(['/plants']);
      //}
    )

 } else {
   // agregar el registro
   this.plantService.create(data).subscribe(
    res => {
      this.salida.emit(res);
      //this.router.navigate(['/plants']);
    }
  );

 }
}

}


